import { type Href, useRouter } from 'expo-router'
import { useCallback } from 'react'

export function useNavigateBack() {
    const router = useRouter()

    const navigateBackTo = useCallback(
        (fallbackPath: string) => {
            if (router.canGoBack()) {
                router.back()
            } else {
                router.push(fallbackPath as Href)
            }
        },
        [router]
    )

    return { navigateBackTo }
}
